export function getPerPersonPrice(price: number, passengers: number): number {
  return Math.ceil(price / passengers);
}
